/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./chainsEdit.vue?vue&type=template&id=1401e906&scoped=true"
import script from "./chainsEdit.vue?vue&type=script&lang=js"
export * from "./chainsEdit.vue?vue&type=script&lang=js"
import style0 from "./chainsEdit.vue?vue&type=style&index=0&id=1401e906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401e906",
  null
  
)

export default component.exports